import { getCurrentUser } from './get_current_user.js';

export const trackCzEvent = (eventName, description, quantity, customFields) => {
  if (typeof window === 'undefined') return;
  const { email } = getCurrentUser();
  if (window.ChurnZero && email.split('@').slice(-1) != 'attunedpartners.com') {
    window.ChurnZero.push(['trackEvent', eventName, description, quantity]);
  }
};
